module.exports = __webpack_public_path__ + "fonts/600-normal-latin-ext.47122d1.woff2";